<section>
    <div class="container">
        <compass-studies-crud-menu></compass-studies-crud-menu>
        <compass-studies-toggle></compass-studies-toggle>
    </div>
</section>